export const IMAGE_TYPE = 'IMAGE';
export const NO_TYPE = 'NONE';
export const VIDEO_TYPE = 'VIDEO';
export const VIDEO_TYPES = ['YOUTUBE', 'VIMEO', 'TWITCH'];

export const isVideoType = (type) =>
  VIDEO_TYPES.some((videoType) => videoType === type);
